const resources = {
  ErrorHuisnummer: "Nummer mag niet groter zijn dan 32767.",
  ErrorPostcode: "Ongeldige postcode.",
  ErrorDatumToekomst: "Datum mag niet in de toekomst liggen.",
  ErrorMaxLengte: "Veld mag maximaal {lengte} lang zijn.",
  ErrorDatumLeeg: "Datum moet leeg zijn.",
  ErrorBedragPostief: "Dient een positief bedrag te zijn.",
  ErrorAantalJaren: "Aantal jaren van 0 t/m 99 invullen.",
  ErrorAantalMaanden: "Aantal maanden van 0 t/m 11 invullen.",
  NavigatiePromptTekst: "Weet je het zeker? Hier staat een tekst uit de resource file.. ?",
  ErrorOnbekendeWaarde: "Onbekende waarde",
  ErrorDatumVerplicht: "Datum is verplicht"
};

export type GeneralTextResources = typeof resources;

export function getGeneralTextResources(id: keyof GeneralTextResources): string {
  return resources[id];
}

export function createGetTextResources<T>(resources: T): (id: keyof T | keyof GeneralTextResources) => string {
  return function getTextResources(id: keyof T | keyof GeneralTextResources): string {
    if (id in resources) {
      return (resources as any)[id];
    }

    return getGeneralTextResources(id as keyof GeneralTextResources);
  };
}
